import { Content, Provider, Root, Trigger } from '@radix-ui/react-tooltip'
import { Children, ReactElement } from 'react'
import { colors } from '~/styles/colors'

interface Props {
  children: [ReactElement, ReactElement]
  delayDuration?: number
  open?: boolean
  onOpenChange?: (open: boolean) => void
  size?: 'sm' | 'default'
}

export const Tooltip = (props: Props) => {
  const { children, delayDuration, open, onOpenChange, size = 'default' } = props

  const [trigger, content] = Children.toArray(children)

  return (
    <Provider>
      <Root
        delayDuration={delayDuration}
        open={open}
        onOpenChange={onOpenChange}
      >
        <Trigger asChild>{trigger}</Trigger>
        <Content
          align="start"
          sideOffset={size === 'sm' ? 4 : 8}
          style={{
            padding: size === 'sm' ? '6px 10px' : '18px 20px',
            fontSize: size === 'sm' ? 12 : undefined,
            background: colors.dark,
            color: colors.white,
            borderRadius: 4,
          }}
        >
          {content}
        </Content>
      </Root>
    </Provider>
  )
}
